'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // Components
// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcSlider = require('rc-slider');

var _rcSlider2 = _interopRequireDefault(_rcSlider);

require('rc-slider/assets/index.css');

require('./styles.css');

var _Container = require('./components/Container.Range');

var _Container2 = _interopRequireDefault(_Container);

var _SliderContainer = require('./components/SliderContainer.Range');

var _SliderContainer2 = _interopRequireDefault(_SliderContainer);

var _Value = require('./components/Value.Range');

var _Value2 = _interopRequireDefault(_Value);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Range = function Range(_ref) {
  var min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      value = _ref.value,
      noLabel = _ref.noLabel;
  return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_SliderContainer2.default, null, _react2.default.createElement(_rcSlider2.default, _extends({
    min: min,
    max: max,
    step: step,
    disabled: disabled,
    onChange: onChange,
    value: value
  }, _styles2.default))), !noLabel && _react2.default.createElement(_Value2.default, null, value));
};

Range.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  step: _propTypes2.default.number,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.number,
  noLabel: _propTypes2.default.bool
};
Range.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  disabled: false,
  value: 0,
  onChange: function onChange() {
    return null;
  },
  noLabel: false
};
exports.default = Range;